import { ShoppingCart } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { PREOWNED_NOTE, formatRM } from "@/data/products";
import ProductImage from "@/components/ProductImage";
import { ConditionBadge } from "@/components/Products";

export default function ProductModal({ product, onClose, onAdd }) {
  return (
    <Dialog open={Boolean(product)} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        className="max-h-[90vh] max-w-2xl overflow-y-auto bg-cream"
        data-testid="product-modal"
      >
        {product && (
          <>
            <DialogHeader>
              <DialogTitle className="font-display text-xl leading-snug text-charcoal">
                {product.name}
              </DialogTitle>
              <DialogDescription className="sr-only">
                Product details for {product.name}
              </DialogDescription>
            </DialogHeader>
            <ProductImage
              product={product}
              className="mt-2 aspect-[4/3] w-full rounded-xl border border-charcoal/10"
              eager
            />
            <div className="mt-4 flex flex-wrap items-center gap-2">
              <span className="rounded-full bg-forest/10 px-3 py-1 text-xs font-semibold text-forest">
                {product.category}
              </span>
              <ConditionBadge condition={product.condition} />
            </div>
            <p className="mt-4 text-2xl font-bold text-forest" data-testid="modal-product-price">
              {formatRM(product.price)}
            </p>
            <dl className="mt-5 space-y-3 text-sm">
              <div>
                <dt className="font-semibold text-charcoal">Condition</dt>
                <dd className="mt-0.5 text-charcoal/75">{product.condition}</dd>
              </div>
              {product.details && (
                <div>
                  <dt className="font-semibold text-charcoal">Details</dt>
                  <dd className="mt-0.5 leading-relaxed text-charcoal/75">{product.details}</dd>
                </div>
              )}
              {product.extras && product.extras.length > 0 && (
                <div>
                  <dt className="font-semibold text-charcoal">Additional information</dt>
                  <dd className="mt-0.5 leading-relaxed text-charcoal/75">
                    <ul className="list-disc space-y-1 pl-5">
                      {product.extras.map((e) => (
                        <li key={e}>{e}</li>
                      ))}
                    </ul>
                  </dd>
                </div>
              )}
            </dl>
            {product.condition === "Pre-owned" && (
              <p className="mt-4 rounded-xl border border-bronze/40 bg-bronze/10 p-4 text-sm leading-relaxed text-charcoal/80" data-testid="preowned-note">
                {PREOWNED_NOTE}
              </p>
            )}
            <button
              type="button"
              onClick={() => onAdd(product.id)}
              className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-forest px-6 py-3 text-sm font-semibold text-cream transition-colors hover:bg-forest-mid"
              data-testid="modal-add-to-cart"
            >
              <ShoppingCart className="h-4 w-4" aria-hidden="true" />
              Add to Cart — {formatRM(product.price)}
            </button>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
